import React from 'react'

import Input from './Input'
import InputButton from './InputButton'
import Popover from '../helpers/Popover'

const PopoverInput = ({ children, onChangeSearch, search, render, minHeight, disabled, actionContent, ...props }) => {
  actionContent = actionContent || <InputButton disabled={disabled} {...props} />

  const inputActionContent = (
    <Input
      iconSize=".9rem"
      iconRight="BsCaretDown"
      onStopTyping={onChangeSearch}
      autoFocus
      value={search}
      placeholder="Busca..."
      {...props}
      // TODO: Fix bug and remove overwrite
      onBlur={() => false}
    />
  )
  const renderActionContent = onChangeSearch && (({ open }) => (open ? inputActionContent : actionContent))

  return (
    <Popover
      actionContent={actionContent}
      noPadding
      parentWidth
      minHeight={minHeight}
      render={render}
      renderActionContent={renderActionContent}
      disabled={disabled}
    >
      {children}
    </Popover>
  )
}

export default PopoverInput
